
const reasons = [
	{
	  image: 'angry-face.png',
	  id: "R1",
	  message: "C’est du passé. On doit privilégier les économies d’énergie et des moyens de production locaux, sans danger et adaptés à chaque territoire.",
	},
	{
	  id: "R2",
	  image: "face-screaming-in-fear.png",
	  message: "C’est trop dangereux. Les centrales sont vulnérables aux aléas naturels et aux attaques.",
	},
	{
	  id: "R3",
	  image: "face-vomiting.png",
	  message: "C’est trop sale. Le nucléaire génère des déchets radioactifs pour des milliers d’années, laissés aux générations futures.",
	},
	{
	  id: "R4",
	  image: "face-with-steam-from-nose.png",
	  message: "C’est trop lent. On a besoin de solutions immédiates et rapides pour le climat, pas de projets pharaoniques lourds.",
	},
	{
	  id: "R5",
	  image: "face-with-symbols-on-mouth.png",
	  message: "Ce n’est pas démocratique. Non à une énergie imposée et un système opaque, oui à des énergies pour, par et avec les citoyen·nes. ",
	},
	{
	  id: "R6",
	  image: "loudly-crying-face.png",
	  message: "C’est trop cher. On doit sortir de ce gouffre financier qui pèse très lourd sur les finances publiques.",
	},

]


const getReasons = () => reasons

const getReason = id => {
	id = id.toLowerCase()
	const r = reasons.filter((r) => r.id.toLowerCase() === id)
	if (!r || !r.length)
		return {
			id: "",
			image: "",
			message: ""
		}

	return r[0]
}

const getMessage = id => {
	const r = getReason(id)
    return r.message
}

const getPicto = id => {
	const r = getReason(id)
    return 'https://cdn.greenpeace.fr/projets/carte-opposition-nucleaire/' + r.image
}

export {
	reasons,
	getReasons,
	getReason,
	getMessage,
	getPicto
}